import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.PRODUCTION) {
  enableProdMode();
}

(function (w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

  const f = d.getElementsByTagName(s)[0];
  const j = d.createElement(s) as HTMLScriptElement; // ✅ cast to HTMLScriptElement
  const dl = l !== 'dataLayer' ? '&l=' + l : '';

  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;

  if (f.parentNode) {
    f.parentNode.insertBefore(j, f);
  }
})(window, document, 'script', 'dataLayer', environment.GTM_ID);

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
